import { Icon } from '@iconify/react'
import ReactApexChart from 'react-apexcharts'
import trendingUpFill from '@iconify/icons-eva/trending-up-fill'
import trendingDownFill from '@iconify/icons-eva/trending-down-fill'
import { alpha, useTheme, styled } from '@material-ui/core/styles'
import { Box, Card, Typography, Stack, Tooltip } from '@material-ui/core'
import { fNumber, fPercent } from '../../../utils/formatNumber'

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.success.main,
  backgroundColor: alpha(theme.palette.success.main, 0.16),
}))

// ----------------------------------------------------------------------

const CHART_DATA = [{ data: [20, 41, 63, 33, 28, 35, 50, 46, 11, 26] }]

export default function AppTotalActiveUsers({title , value = 0 , percentage = 0}) {
  const theme = useTheme()

  const chartOptions = {
    colors: [theme.palette.primary.main],
    chart: { sparkline: { enabled: true } },
    plotOptions: { bar: { columnWidth: '68%', borderRadius: 2 } },
    labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
    tooltip: {
      enabled: false,
    },
  }

  return (
    <Tooltip title="New Booking Per Day" placement="top">
    <Card sx={{ display: 'flex', alignItems: 'center', p: 3 }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2">New Bookings</Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ mt: 2, mb: 1 }}
        >
          <IconWrapperStyle
            sx={{
              ...(percentage < 0 && {
                color: 'error.main',
                bgcolor: alpha(theme.palette.error.main, 0.16),
              }),
            }}
          >
            <Icon
              width={16}
              height={16}
              icon={percentage >= 0 ? trendingUpFill : trendingDownFill}
            />
          </IconWrapperStyle>
          <Typography component="span" variant="subtitle2">
            {percentage > 0 && '+'}
            {fPercent(percentage)}
          </Typography>
        </Stack>

       <Typography variant="h5">{fNumber(value)}</Typography>
      </Box>

      <ReactApexChart
        type="bar"
        series={CHART_DATA}
        options={chartOptions}
        width={60}
        height={36}
      />
    </Card>
    </Tooltip>
  )
}
